import React from 'react';
import NewDynamicTable from '../../shared/NewDynamicTable';
import { getDefaultPagingNumberOfItems } from '../../../helpers/PackageJsonHelper';
import { GetActiveContactsByCustomer } from '../../../networking/NetworkingContacts';
export default class ContactSearch extends React.Component {
    state = {
        contactList: [],
        pages:0,
        newSearch:false,
    }

    componentDidMount(){
        this.loadContacts(1, true);
    }

    changePage(page){
        this.loadContacts(page, false);
    }

    loadContacts = async(page, newSearch) =>{
        const itemsPerPage = getDefaultPagingNumberOfItems();
        const json = await GetActiveContactsByCustomer(this.props.objCustomer["Customer ID"], page, itemsPerPage);

            var totalCount = json.totalCount;
            if (this.props.contacts_length != null) {
                this.props.contacts_length(totalCount);
            }
            var pages = Math.ceil(totalCount/itemsPerPage);
            var helper = [];
            if(totalCount >0){
                helper = json.contacts;
            }
            this.setState({contactList: helper,
                pages: pages,
                newSearch: newSearch});
        
    }

    handleRecordClick =(objContact) =>{
        this.props.onContactSelected(objContact);
    }

    handleBackClick = (event) =>{
        this.props.onBackClick();
    }

    render(){
        return(
            <form>
                {/* <div className="uk-width-1-1">
                    <h1>Contacts for customer {this.props.objCustomer["Customer Name"]}</h1>
                </div> */}
                <div className="uk-width-1-1">
                    <NewDynamicTable data={this.state.contactList}
                        enableClick={true}
                        clickFunction={this.handleRecordClick}
                        newSearch={this.state.newSearch} 
                        useDeleteButton={false}/>                       
                </div>
            </form>
        )
    }
}